import React from "react";

export type ButtonTypes = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
};

const Button = React.forwardRef<HTMLButtonElement, ButtonTypes>(
  ({ children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className="flex items-center h-10 px-4 py-3 rounded border-2 border-primary-400 text-primary-400 font-texts font-bold text-sm cursor-pointer transition-transform transform active:scale-95"
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";
export default Button